// extracted by mini-css-extract-plugin
module.exports = {"standard":"standard__ibm9Y","disabled":"disabled__dTs+1","input":"input__s7qex","label":"label__T8C0r"};